import React from 'react';

import {
  Home as HomeView,
  MoneyPage,
  TransactionsPage,
  CommitmentsPage,
  GoalsPage,
  BankAccountsPage,
  CoachPage,
  SpendingAnalysisPage,
  HouseholdPage,
  AcceptInvitePage,
  SubscriptionPage,
  BusinessHomePage,
  BusinessSetupWizard,
  BusinessWorkspacePage,
  ForecastPage,
  AchievementsPage,
} from 'apps/user';

const userRoutes = [
  {
    path: '/user/home',
    renderer: (params = {}): JSX.Element => <HomeView {...params} />,
  },
  {
    path: '/user/money',
    renderer: (params = {}): JSX.Element => <MoneyPage {...params} />,
  },
  {
    path: '/user/transactions',
    renderer: (params = {}): JSX.Element => <TransactionsPage {...params} />,
  },
  {
    path: '/user/commitments',
    renderer: (params = {}): JSX.Element => <CommitmentsPage {...params} />,
  },
  {
    path: '/user/goals',
    renderer: (params = {}): JSX.Element => <GoalsPage {...params} />,
  },
  {
    path: '/user/bank-accounts',
    renderer: (params = {}): JSX.Element => <BankAccountsPage {...params} />,
  },
  {
    path: '/user/coach',
    renderer: (params = {}): JSX.Element => <CoachPage {...params} />,
  },
  {
    path: '/user/spending-analysis',
    renderer: (params = {}): JSX.Element => (
      <SpendingAnalysisPage {...params} />
    ),
  },
  {
    path: '/user/household',
    renderer: (params = {}): JSX.Element => <HouseholdPage {...params} />,
  },
  {
    path: '/user/household/accept/:token',
    renderer: (params = {}): JSX.Element => <AcceptInvitePage {...params} />,
  },
  {
    path: '/user/subscription',
    renderer: (params = {}): JSX.Element => <SubscriptionPage {...params} />,
  },
  {
    path: '/user/business',
    renderer: (params = {}): JSX.Element => <BusinessHomePage {...params} />,
  },
  {
    path: '/user/business/:id/setup',
    renderer: (params = {}): JSX.Element => <BusinessSetupWizard {...params} />,
  },
  {
    path: '/user/business/:id',
    renderer: (params = {}): JSX.Element => (
      <BusinessWorkspacePage {...params} />
    ),
  },
  {
    path: '/user/forecast',
    renderer: (params = {}): JSX.Element => <ForecastPage {...params} />,
  },
  {
    path: '/user/achievements',
    renderer: (params = {}): JSX.Element => <AchievementsPage {...params} />,
  },
];

export default userRoutes;
